var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVXvs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.666 1.119a1.584 1.584 0 0 1 2.067.864L10.39 10.9h11.27l3.94-8.953a1.584 1.584 0 1 1 2.9 1.276L25.12 10.9h4.008a1.584 1.584 0 1 1 0 3.17H3.584a1.584 1.584 0 1 1 0-3.169h3.38L3.803 3.187a1.584 1.584 0 0 1 .864-2.067zM2 18.425c0-.875.71-1.584 1.584-1.584h25.544a1.584 1.584 0 1 1 0 3.168h-7.21l-4.721 10.078a1.584 1.584 0 0 1-2.874-.01L9.697 20.01H3.584C2.71 20.01 2 19.3 2 18.426zm11.184 1.584 2.592 5.642 2.643-5.642h-5.236z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVXvs);
export default __webpack_public_path__ + "static/media/vXVS.f02fe1c97cfdf88d572b207fcd2fbc0b.svg";
export { ForwardRef as ReactComponent };